import * as React from 'react'

import { cn } from '@/lib/utils'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const OptionsBody: React.FC<IProps> = ({ className, children, ...rest }) => {
  return (
    <div
      data-slot="options-body"
      className={cn(
        'tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:gap-2',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default OptionsBody
